export default function ({ $axios, $config }) {
  $axios.setBaseURL($config.APIV2_URL || '');
}